import type { SimilarTest } from '@@/api/learnings/similar/similar-types';
import { Link } from 'react-router';
import { cn } from '@/lib/utils';
import { similarSentence } from '@/state/learnings/similar-copy';
import { FOCUS_RING } from '../../../ConsolePanel';

export type SimilarPastTestsProps = {
  matches: readonly SimilarTest[];
  /** The current time, for "in March" against "in March 2025". A prop so a test can pin it. */
  now?: number;
};

/**
 * "#412 tested this in March: lost, -2.8%." Past and current tests on this website that this
 * draft resembles, so a website does not re-run its own losses.
 *
 * Renders nothing without a match: most drafts have none, and an empty panel on every draft
 * would train people to ignore the one that matters. Names are people's text and are rendered
 * as text.
 */
export const SimilarPastTests = ({ matches, now = Date.now() }: SimilarPastTestsProps) => {
  if (matches.length === 0) return null;

  return (
    <div className="border-line flex flex-col gap-2 border-t pt-4">
      <div>
        <h3 className="micro-label text-foreground">Similar past tests</h3>
        <p className="supporting mt-1">Tests on this website that look like this one.</p>
      </div>
      <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
        {matches.map((test) => (
          <li key={test.experimentId} className="text-foreground text-body">
            <Link
              to={`/experiments/${test.experimentId}`}
              className={cn('rounded-sm underline underline-offset-2', FOCUS_RING)}
            >
              #{test.experimentId}
            </Link>{' '}
            {similarSentence({ test, now })} <span className="supporting">{test.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
